import React, { useState, useImperativeHandle } from "react";
import { Confirm } from "semantic-ui-react";

import { markDataLayerFieldToDelete } from "./orthoControlFunctions";

const DataLayerDeleteModal = React.memo(
	React.forwardRef((_, modalRef) => {
		const [modalOpen, setModalOpen] = useState<boolean>(false);
		const [fieldId, setFieldId] = useState<string | null>(null);
		const [activeElement, setActiveElement] = useState<HTMLElement | null>(null);
		const [fieldIds, setFieldIds] = useState<string[]>([]);

		useImperativeHandle(modalRef, () => {
			return {
				updateFieldId: (id: string) => setFieldId(id),
				openModal: () => setModalOpen(true),
				updateActiveElement: (element: HTMLElement) => setActiveElement(element),
				setFieldIds: (ids: string[]) => setFieldIds(ids),
			};
		});

		const handleConfirm = () => {
			if (fieldIds.length > 0) {
				fieldIds.forEach((fieldId: string) => {
					markDataLayerFieldToDelete(fieldId);
				});
			} else if (fieldId) {
				markDataLayerFieldToDelete(fieldId);
			}

			handleClose();
			activeElement?.focus();
		};

		const handleClose = () => {
			setFieldId(null);
			setFieldIds([]);
			setModalOpen(false);
		};

		return (
			<>
				<Confirm
					open={modalOpen}
					content={
						"You are about to update the first flight of a field that has data layers uploaded to it. Doing so will delete all associations to that data layer and you will need to re-associate them. Do you want to continue?"
					}
					cancelButton={"Cancel"}
					confirmButton={"Confirm"}
					onCancel={() => {
						handleClose();
						activeElement?.focus();
					}}
					onConfirm={() => handleConfirm()}
				/>
			</>
		);
	}),
);

DataLayerDeleteModal.displayName = "DataLayerDeleteModal";

export default DataLayerDeleteModal;
